import React, { useEffect } from 'react';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
styled.h4(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tcolor: #141823;\n\tpadding-left: 6px;\n"])));
var SearchCardHeaderWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n"])));
var SearchHeaderInfoWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var PeopleCountText = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tcolor: #777777;\n\tfont-size: 11px;\n\tline-height: 13px;\n\tpadding: 0 2px;\n"])));
var LocationWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 18px;\n"])));
var SearchValue = styled.h4(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tline-height: 14px;\n\tcolor: #141823;\n\tfont-weight: 500;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\ttext-transform: capitalize;\n\tmax-width: ", ";\n"])), function (props) {
  return props.fullwidth ? 'auto' : '118px';
});
var Middle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tmargin: 0 8px;\n"])));
var DateWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\tmargin-top: 10px;\n\tfont-size: 11px;\n\tline-height: 13px;\n\tcolor: #777777;\n\tpadding-right: 4px;\n\tmargin-right: 4px;\n\tborder-right: 1px solid #777777;\n\t&:last-child {\n\t\tmargin-right: 0;\n\t\tpadding-right: 0;\n\t\tborder-right: none;\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t}\n"])));
var SearchCard = styled.li(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n\tpadding: 8px;\n\twidth: 280px;\n\theight: 114px;\n\tbackground: #ffffff;\n\tborder: 1px solid #dcdcdc;\n\tborder-radius: 8px;\n\tmargin-right: 8px;\n\tflex-shrink: 0;\n\tlist-style: none;\n\tcursor: pointer;\n"])));
var SearchTypeDesc = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 4px 8px;\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tline-height: 12px;\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-radius: 10px;\n\ttext-transform: uppercase;\n"])), function (props) {
  return props.textColor;
}, function (props) {
  return props.bgColor;
});
var IconWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n\twidth: 18px;\n\theight: 18px;\n\tbackground-image: url(", ");\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n"])), function (props) {
  return props.img;
});

var RecentSearchCardDweb = function RecentSearchCardDweb(props) {
  var onClick = props.onClick,
    searchObj = props.searchObj,
    onLoad = props.onLoad;
  var lob = searchObj.lob,
    subLob = searchObj.subLob,
    badgeText = searchObj.badgeText,
    lobBgColor = searchObj.lobBgColor,
    lobTextColor = searchObj.lobTextColor,
    left = searchObj.left,
    right = searchObj.right,
    middle = searchObj.middle,
    paxText = searchObj.paxText,
    paxIcon = searchObj.paxIcon,
    date = searchObj.date;
    searchObj.gd;
    searchObj.tg;
    var ctaUrl = searchObj.ctaUrl;
  useEffect(function () {
    onLoad == null || onLoad(searchObj);
  }, []);
  var handleOnClick = function handleOnClick() {
    onClick(searchObj);
  };
  return /*#__PURE__*/React.createElement(SearchCard, {
    key: lob + "-" + subLob + "-" + date + "-" + ctaUrl,
    onClick: handleOnClick
  }, /*#__PURE__*/React.createElement(SearchCardHeaderWrapper, null, /*#__PURE__*/React.createElement(SearchTypeDesc, {
    bgColor: lobBgColor,
    textColor: lobTextColor
  }, badgeText), /*#__PURE__*/React.createElement(SearchHeaderInfoWrapper, null, paxText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconWrapper, {
    img: paxIcon
  }), /*#__PURE__*/React.createElement(PeopleCountText, null, paxText)))), /*#__PURE__*/React.createElement(LocationWrapper, null, left && /*#__PURE__*/React.createElement(SearchValue, null, left), /*#__PURE__*/React.createElement(Middle, null, /*#__PURE__*/React.createElement(IconWrapper, {
    img: middle
  })), right && /*#__PURE__*/React.createElement(SearchValue, {
    fullwidth: !left
  }, right)), date ? /*#__PURE__*/React.createElement(DateWrapper, null, date) : null);
};

export { RecentSearchCardDweb };
